import React, { useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {EditorState, ContentState, convertFromRaw, convertToRaw} from 'draft-js';
import "./TextEditor.css";
import draftToHtml from "draftjs-to-html";


function TextEditor(props){
    let value = EditorState.createEmpty();
    const [editorState, setEditorState] = useState(props.editorValue)

    const onEditorStateChange = (editorstate) => {
        setEditorState(editorstate)
        var markupContent;
        const rawContentState = convertToRaw(
            editorState.getCurrentContent()
          );
          markupContent = draftToHtml(rawContentState);
    }
    
    return(
        <Editor
        toolbar={{
            options: [
              'inline',
              'list',
            //   'textAlign',
            //   'link',
            ],
            inline: {inDropdown:false,options: ['bold', 'italic', 'underline','strikethrough']},
            list: {inDropdown: false},
            textAlign: {inDropdown: true},
            link: {inDropdown: false},       
          }}
        // placeholder={props.readOnly?"":"Start typing here..."}
        editorState={props.editorValue}
        toolbarClassName="toolbarClassName"
        wrapperClassName="demo-wrapper"
        editorClassName={props.readOnly?"nonEdit":"editorClassName"}
        onEditorStateChange={props.onEditorStateChange}
        readOnly={props.readOnly}
        toolbarHidden={props.toolbarHidden}
        handleBeforeInput={props.handleBeforeInput}
        handlePastedText={props.handlePastedText}
        />
           
    )
}
export default TextEditor;